import type { ReactNode } from 'react';
import type { ImageSourcePropType } from 'react-native';

import { VideoPreparation } from './VideoPreparation';

export type AppleEedVideoPreparationProps = {
  title: string;
  shareLabel: string;
  shareImage: ImageSourcePropType;
  inverse?: boolean;
  footer?: ReactNode;
};

export function AppleEedVideoPreparation({ title, shareLabel, shareImage, inverse = false, footer }: AppleEedVideoPreparationProps) {
  return (
    <VideoPreparation
      title={title}
      testID="incident-video-apple-eed-preparation-panel"
      inverse={inverse}
      footer={footer}
      actions={[{ label: shareLabel, image: shareImage, aspectRatio: 948 / 1659 }]}
    />
  );
}
